import { BusinessTrip } from "@models";
import React from "react";

type TripContextValue = {
	currentTrip: BusinessTrip;
	isEditable: boolean;
};

export default React.createContext<TripContextValue | null>(null);
